const getPrefixUrl = (channelUrl?: string, isPreview?: boolean) => {
  if (!channelUrl) return '';
  //If the event url is not a custom url, it will be something.brand.live.
  if (channelUrl.includes('brand.live')) {
    const baseUrl = import.meta.env.VITE_BASE_URL;
    //If we are in a live environment (non local), it will have an env variable of the form https://brandlive-someenvironment.com
    if (baseUrl) {
      if (isPreview) {
        return baseUrl.replace('https://', 'https://admin.');
      }

      return baseUrl.replace('https://', 'https://' + channelUrl.split('.')[0] + '.');
    } else {
      if (isPreview) {
        return 'https://admin.brandlive-dev.com';
      }

      //If we are in local environment, use brandlive-dev.com.
      return 'https://' + channelUrl.split('.')[0] + '.brandlive-dev.com';
    }
  } else {
    //If custom url, use whole url.
    return 'https://' + channelUrl;
  }
};

export default getPrefixUrl;
